import { useCallback } from 'react';
import { updateRecurringTaskDetails } from '../../services/taskServices';
import { DropdownItem } from '../dropdown';
import { Submenu } from './styles';
import { rootStore } from '../../mobx/rootStore';
import { TaskModel } from '../../mobx/models/task';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

interface Props {
  data?: TaskModel;
  loadData?: () => void;
}
export default function SubmenuWeeklyMenu(props: Props) {
  //mobx store
  const { taskStore } = rootStore;
  const { createTaskInput } = taskStore;

  const setWeeklyRecurringTask = useCallback(
    async (day: string) => {
      try {
        const payloadTask = {
          projectId: props?.data?.projectId,
          start: day.toLowerCase(),
          recurringInterval: 'weekly'
        };
        const response = await updateRecurringTaskDetails(props?.data?.id, payloadTask);
        if (response) {
          props?.loadData?.();
        }
        rootStore.taskStore.createTaskInput.setStart(day);
        rootStore.taskStore.createTaskInput.setRecurringInterval('weekly');
      } catch (error) {
        console.log('error', error);
      }
    },
    [props]
  );
  return (
    <Submenu>
      {days.map((day) => (
        <DropdownItem
          key={day}
          isSelected={createTaskInput?.start === day.toString()}
          onClick={() => setWeeklyRecurringTask(day)}>
          {day}
        </DropdownItem>
      ))}
    </Submenu>
  );
}
